import * as React from 'react';

import {Card} from 'shells/card/card';
import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

import styles from './special-states.module.css';

export function TimelineErrorState() {
    return (
        <div className={styles['outer-container']}>
            <Card hasBorder={true} fitHeight={true} fitContent={true}>
                <div className={styles['inner-container']}>
                    <EmptyStateSmall
                        title='Oh no! Something went wrong'
                        subtitle='There was an error retrieving these timeline entries'
                        icon={
                            <div style={{width: '100px'}}>
                                <Illustration src='plug-error-state' width='100%' height='100%' />
                            </div>
                        }
                    />
                </div>
            </Card>
        </div>
    );
}
